module.exports = __webpack_public_path__ + "media/Video 35.9c5684f8.mp4";